
let TestModel = require('@/mixins/Forms/2019/TestModel')

module.exports = {

    mixins: [TestModel],

    data(){
        return {
            construction_inspection: {
                name: `A. Construction Inspection (NA7.7.5.2.1)`,
                questions: {
                    question_1: {
                        id: `a`,
                        question: `The controls or the methods of controlling the maximum output of luminaires is such that the maximum light output of the controlled lighting system can be limited. (NA7.7.5.2.1(a))`,
                        answer: false,
                    },
                    question_2: {
                        id: `b`,
                        question: `The controls or the methods of controlling the maximum output of luminaires is such that normal operation of the controlled lighting does not override the maximum light output. (NA7.7.5.2.1(a))`,
                        answer: false
                    },
                    question_3: {
                        id: `c`,
                        question: `The controls are not readily accessible to unauthorized personnel. (NA7.7.5.2.1(b), Section 140.6(a)2Jii)`,
                        answer: false
                    },
                },
                result: false,
            }
        }
    },

    mounted() {
        this.form = new Form({
            construction_inspection: this.construction_inspection,
            functional_test: this.functional_test,
            comments: '',
            testResult: false,
        }, false)
        this.loadFormData();
    },

    methods: {

        initTest() {

            if (!this.testIsReady) {
                return;
            }

            this.constructionInspectionEvaluation();
            this.functionalTestEvaluation();

            this.form.testResult = (this.form.construction_inspection.result && this.form.functional_test.result);
        },

        constructionInspectionEvaluation() {
            this.form.construction_inspection.result = true;
            _.each(this.form.construction_inspection.questions, (question, i) => {
                if (!question.answer) {
                    this.form.construction_inspection.result = false;
                }
            })
        },

        functionalTestEvaluation() {
            // Needs to be called from the test component.
        },

        loadFormData() {

            if(this.data == null){
                return;
            }

            _.each(this.data.construction_inspection.questions, (question, i) => {
                this.form.construction_inspection.questions[i].answer = question.answer;
            })

            _.each(this.data.functional_test.steps, (step, i) => {
                _.each(step.questions, (question, j) => {
                    if (!this.isText(this.form.functional_test.steps[i].questions[j])) {
                        this.form.functional_test.steps[i].questions[j].answer = question.answer
                    }
                })
            })

            this.form.comments = this.data.comments;
        },
    },
}
